module.exports = __webpack_public_path__ + "img/dissapointment.113677f5.svg";